var map = {
	"./app/code_front_end/routes.js": "c5b5",
	"./app/code_login_type/routes.js": "0651",
	"./app/code_quote_status/routes.js": "93fa",
	"./app/code_quote_type/routes.js": "37e1",
	"./app/code_task_type/routes.js": "bd56",
	"./app/code_user_story_status/routes.js": "378f",
	"./app/database/routes.js": "d775",
	"./app/document_template/routes.js": "3bcf",
	"./app/framework/routes.js": "148a",
	"./app/language/routes.js": "a801",
	"./app/ocom_client/routes.js": "647d",
	"./app/ocom_project/routes.js": "71c5",
	"./app/ocom_quote/routes.js": "b0d0",
	"./app/ocom_quote_old/routes.js": "568c",
	"./app/routes.js": "8dfe",
	"./app/timesheet_entry/routes.js": "9da1",
	"./app/user_role/routes.js": "f9a1",
	"./app/user_story/routes.js": "f62b",
	"./vue-ocom/auth/routes.js": "a7f5",
	"./vue-ocom/grouppermissions/content_type/routes.js": "8f71",
	"./vue-ocom/grouppermissions/group/routes.js": "5ef6",
	"./vue-ocom/grouppermissions/group_permissions/routes.js": "36cf",
	"./vue-ocom/grouppermissions/permission/routes.js": "c195",
	"./vue-ocom/grouppermissions/user/routes.js": "c251",
	"./vue-ocom/reports/routes.js": "74b6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bd01";